module.exports = __webpack_public_path__ + "static/media/Leprechaun.b6449e92.jpg";